var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBinanceWithdraw(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.08722 7.00869L2.48306 8.58736L0.878906 7.00869L2.48306 5.42997L4.08722 7.00869ZM8.00066 3.15737L10.7506 5.88106L12.3548 4.30235L9.60482 1.57869L8.00066 0L6.3965 1.57869L3.62889 4.30235L5.23304 5.88106L8.00066 3.15737ZM13.5183 5.42997L11.9141 7.00869L13.5183 8.58736L15.1224 7.00869L13.5183 5.42997ZM8.00066 10.8426L5.25067 8.13632L3.62889 9.71499L6.37888 12.4213L7.98304 14L9.5872 12.4213L12.3548 9.71499L10.7506 8.13632L8.00066 10.8426ZM8.00066 8.58736L9.60482 7.00869L8.00066 5.42997L6.3965 7.00869L8.00066 8.58736Z",
    fill: "#F0B90B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceWithdraw);
export default __webpack_public_path__ + "static/media/binanceWithdraw.47a2d17b1b4b2df9495853e267fda77f.svg";
export { ForwardRef as ReactComponent };